/* Circuit-board background trace pattern. Draws once on load and on resize;
   fixed behind the whole page so it reads as one continuous surface rather
   than resetting per section. Respects the "Enable animated background"
   theme setting (this file is only loaded when that's on) and prefers-reduced-motion
   (the pattern itself is static; only the glow/scan-line layers in mcb.css animate). */
(function () {
  var canvas = document.getElementById('mcb-circuit');
  if (!canvas || !canvas.getContext) { return; }
  var ctx = canvas.getContext('2d');
  var W, H, nodes = [];
  var CELL = 96;

  function resize() {
    W = canvas.width = window.innerWidth;
    H = canvas.height = document.documentElement.scrollHeight;
    canvas.style.height = H + 'px';
    buildNodes();
    draw();
  }

  function buildNodes() {
    nodes = [];
    var cols = Math.ceil(W / CELL) + 1;
    var rows = Math.ceil(H / CELL) + 1;
    for (var r = 0; r < rows; r++) {
      for (var c = 0; c < cols; c++) {
        /* deterministic pseudo-random offset so it looks hand-routed, not a
           perfect grid, and stays identical between resizes/reloads */
        var seed = (r * 928371 + c * 133331) % 1000 / 1000;
        if (seed > 0.62) { continue; }
        nodes.push({
          x: c * CELL + (seed - 0.5) * 30,
          y: r * CELL + ((seed * 7) % 1 - 0.5) * 30,
          big: seed > 0.85
        });
      }
    }
  }

  function draw() {
    ctx.clearRect(0, 0, W, H);
    ctx.strokeStyle = 'rgba(20,23,26,0.16)';
    ctx.lineWidth = 1;
    ctx.fillStyle = 'rgba(20,23,26,0.22)';

    /* connect each node to its right/down neighbour in right-angle traces -
       reads as a routed PCB rather than a plain grid */
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      var right = nodes.find(function (m) { return Math.abs(m.y - n.y) < 4 && m.x > n.x && m.x - n.x < CELL * 1.6; });
      var down = nodes.find(function (m) { return Math.abs(m.x - n.x) < 4 && m.y > n.y && m.y - n.y < CELL * 1.6; });
      if (right) { ctx.beginPath(); ctx.moveTo(n.x, n.y); ctx.lineTo(right.x, n.y); ctx.stroke(); }
      if (down) { ctx.beginPath(); ctx.moveTo(n.x, n.y); ctx.lineTo(n.x, down.y); ctx.stroke(); }
      ctx.beginPath();
      ctx.arc(n.x, n.y, n.big ? 2.6 : 1.6, 0, Math.PI * 2);
      ctx.fill();
    }
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(resize, 150);
  });
  resize();
})();
